import React, { } from "react";

import { SPEC_FLAGS_MAP } from "../../../../../Common/constants/SpecFlagConstants";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { getVisibleSpecFlag } from "../../../../../grace-period/utils";
// import { PINS_SPEC_STYLE_MAP } from "../../Constant";

import { ReactComponent as PinIcon } from "../../../../../../assets/images/environment/pinIconSVG.svg";
// import { ReactComponent as StatusDotIcon } from "../../../../../../assets/images/environment/statusPingDot.svg";

import "./CorrectiveActionPin.css";

export default function CorrectiveActionPin({
  pin,
  // pinElementRef,
  // zoomToElement,
}) {
  /** Zoom to pin */
  // const handleZoomToPin = () => {
  //   if (pinElementRef.current !== null) {
  //     zoomToElement(pinElementRef.current, 2);
  //   }
  // };

  /** When pin changes, re-zoom to pin */
  // useEffect(() => {
  //   handleZoomToPin();
  // }, [pin]); // eslint-disable-line

  /** When window size changes, re-zoom to pin */
  // useEffect(() => {
  //   window.addEventListener("resize", handleZoomToPin);

  //   return () => {
  //     window.removeEventListener("resize", handleZoomToPin);
  //   };
  // });

  const { areResultsLocked } = useAccessStatus();
  const { color, border_color } = SPEC_FLAGS_MAP[getVisibleSpecFlag(pin.specs_flag, areResultsLocked)] ?? SPEC_FLAGS_MAP.invalid;

  return (
    // <div
    //   className="report-pin-location-container"
    //   // ref={pinElementRef}
    //   style={{ left: `calc(${(pin.x_coordinate * 100)}% - 18px)`, top: `calc(${(pin.y_coordinate * 100)}% - 18px)` }}
    // >
    //   <div
    //     className="report-pin-container"
    //   >
    //     <StatusDotIcon width={36} height={36} fill={color} />
    //   </div>
    // </div>
    <div
      className="CorrectiveActionPin pin-container"
      style={{
        left: `${(pin.x_coordinate * 100)}%`,
        top: `${(pin.y_coordinate * 100)}%`,
      }}
    >
      <div
        className="CorrectiveActionPin swab-number-pin-border"
        style={{
          border: `0.5px solid ${border_color}`,
          backgroundColor: border_color,
        }}
      >
        <div
          className="CorrectiveActionPin swab-number-pin-background"
          style={{
            backgroundColor: color,
          }}
        >
          <div
            className="CorrectiveActionPin circular-pin-solid-circle"
          >
            <PinIcon
              width={9}
              height={9}
              fill={color}
            />
          </div>
          <div
            className="CorrectiveActionPin sample_id"
          >
            {pin.sample_id}
          </div>
        </div>
        <div
          className="CorrectiveActionPin swab-number-pin-arrow"
          style={{
            borderTop: `7px solid ${color}`,
          }}
        />
      </div>
    </div>
  );
}
